export const fontSizes = {
  button: '0.875rem', // 14px
  p5: '0.5rem', // 8px
  p4: '0.625rem', // 10px
  p3: '0.75rem', // 12px
  p2: '0.875rem', // 14px
  p1: '1rem', // 16px
  p0: '1.125rem', // 18px
  h6Mobile: '1rem', // 16px
  h6: '1rem', // 16px
  h5Mobile: '1.25rem', // 20px
  h5: '1.25rem', // 20px
  h4Mobile: '1.5rem', // 24px
  h4: '1.5rem', // 24px
  h3Mobile: '1.75rem', // 28px
  h3: '2.125rem', // 34px
  h2Mobile: '2.125rem', // 34px
  h2: '2.5rem', // 40px
  h1Mobile: '2.5rem', // 40px
  h1: '3.125rem', // 50px
  promoText: '2.5rem', // 120px
  promoTitle: '7.5rem', // 40px
};
